import React from 'react';

export const HeaderSurvey = ({label}) => {
  return (
    <div className='heading' >
      {label}
    </div>
  );
};